export default __webpack_public_path__ + "static/media/logo-spotify.1f5a1f92.svg";